import { useStore } from 'zustand';
import { useContext } from 'react';
import { ModelContext } from '../contexts';
export default function useModelContext(selector, equalityFn) {
  const store = useContext(ModelContext);
  if (!store) {
    throw new Error('Missing "ModelContext.Provider" in the tree');
  }
  return useStore(store, selector, equalityFn);
}